/**
 * 招待トークンから受諾 URL を組み立てる（課題 #54）。
 * AcceptInvite 画面が `?invite_token=` を読む実装になっているのに合わせる。
 * 単体の招待・再送と、CSV の一括登録（#94）で使う。
 */
export function buildAcceptUrl(inviteToken: string): string {
  return `${window.location.origin}/accept-invite?invite_token=${encodeURIComponent(inviteToken)}`;
}
